import React from "react";
import { Button, FormLayout, TextField } from "@shopify/polaris";
import AuthContainer from "../../AuthContainer";
import eyeOnIMG from "img/icons/misc/eye-on.svg";
import eyeOffIMG from "img/icons/misc/eye-off.svg";
import useLogInAdminPage from "../../shared/hooks/useLogInAdminPage";

export default function LogInAdminPage() {
  const {
    loggingIn,
    email,
    errorEmail,
    password,
    errorPassword,
    showPassword,
    setEmail,
    validateLogin,
    togglePasswordVisibility,
    handlePasswordChange,
    doLogin,
  } = useLogInAdminPage();

  return (
    <AuthContainer
      title="Authorization"
      description="Please login to the system"
      content={
        <FormLayout>
          <TextField
            name="email"
            type="text"
            placeholder="Login"
            value={email}
            error={errorEmail}
            onBlur={() => validateLogin(email)}
            onChange={setEmail}
          />
          <TextField
            name="password"
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            error={errorPassword}
            suffix={
              <img
                src={showPassword ? eyeOffIMG : eyeOnIMG}
                alt={showPassword ? "Hide password" : "Show password"}
                style={{
                  marginTop: 6,
                  cursor: "pointer",
                  width: "20px",
                  height: "20px",
                }}
                onClick={togglePasswordVisibility}
              />
            }
            onChange={handlePasswordChange}
          />
          <Button
            disabled={loggingIn}
            loading={loggingIn}
            variant="primary"
            onClick={doLogin}
          >
            Sign In
          </Button>
        </FormLayout>
      }
    />
  );
}
